import type { Blob as MatterBlob } from '@/services/types/blob-types';

const PDF_FILENAME_REGEX = /\.pdf$/i;
const IMAGE_FILENAME_REGEX = /\.(png|jpe?g|webp|gif)$/i;

const getBlobNameVariants = (blob: MatterBlob): string[] =>
  [blob.name, blob.original_filename]
    .filter((value): value is string => Boolean(value))
    .map((value) => value.toLowerCase());

const isPdfSourceBlob = (blob: MatterBlob): boolean =>
  blob.file_mime_type === 'application/pdf' ||
  blob.file_extension?.toLowerCase() === 'pdf' ||
  getBlobNameVariants(blob).some((filename) => PDF_FILENAME_REGEX.test(filename));

const isImageSourceBlob = (blob: MatterBlob): boolean =>
  blob.file_mime_type?.startsWith('image/') === true ||
  ['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(
    blob.file_extension?.toLowerCase() || '',
  ) ||
  getBlobNameVariants(blob).some((filename) =>
    IMAGE_FILENAME_REGEX.test(filename),
  );

export const isMatterSignatureSourceBlob = (blob: MatterBlob): boolean => {
  return isImageSourceBlob(blob) || isPdfSourceBlob(blob);
};
